export default "__VITE_ASSET__89a334a7__"